import { createReducer, on } from "@ngrx/store";
import { Customer } from "../../models/customer.model";
import { customersActions } from "./customers.actions";

export interface CustomerState {
    customers: Customer[]|null,
    state: 'pending'|'loading'|'loaded'|'error'
}

export const initialState: CustomerState = {
    customers: null,
    state: 'pending'
};

export const customersReducer = createReducer(
    initialState,
    on(customersActions.loadCustomers, (state) => ({
        ...state,
        customers: null,
        state: 'loading' as const
    })),
    on(customersActions.loadCustomersSuccess, (state, {payload}) => ({
        ...state,
        customers: payload,
        state: 'loaded' as const
    })),
    on(customersActions.loadCustomerFail, (state) => ({
        ...state,
        customers: null,
        state: 'error' as const
    }))
)